import { connect } from 'react-redux';

import { openInsertHeaderLogoImageModal } from '../../../actions/headerEditorActions';
import HeaderLogoPlaceholder from '../HeaderLogoPlaceholder';

const mapDispatchToProps = {
  onUploadImage: openInsertHeaderLogoImageModal,
};

export default connect(
  null,
  mapDispatchToProps,
)(HeaderLogoPlaceholder);
